/**
 * Сегмент URL панели администрирования (без слэшей).
 * В production задайте уникальное значение в .env: REACT_APP_ADMIN_PANEL_BASE=ваш-секретный-сегмент
 */
function trimSlashes(s: string): string {
    return s.replace(/^\/+|\/+$/g, '');
}

const DEFAULT_BASE = 'a7f3e9b2-c8d1-internal-panel';

const fromEnv = trimSlashes(process.env.REACT_APP_ADMIN_PANEL_BASE || DEFAULT_BASE);

export const ADMIN_PANEL_BASE_PATH = fromEnv || DEFAULT_BASE;

/** Например /a7f3e9b2-c8d1-internal-panel */
export const ADMIN_PANEL_BASE = `/${ADMIN_PANEL_BASE_PATH}`;

/** Путь к подстранице: adminPanelUrl('auth') → /{base}/auth */
export function adminPanelUrl(subPath = ''): string {
    const sub = trimSlashes(subPath);
    if (!sub) {
        return ADMIN_PANEL_BASE;
    }
    return `${ADMIN_PANEL_BASE}/${sub}`;
}
